<template>
  <div class="content flex w-full h-full">
    <div class="navbar" :class="{ 'shrink-menu': !expandedMenu }" v-if="!isMobile">
      <TheSidebar :sidebarStatus="expandedMenu" />
    </div>
    <div class="mobile-sidebar" :class="{ 'expand-menu': !expandedMenu }" v-else>
      <TheMobileSidebar :sidebarStatus="expandedMenu" />
    </div>
    <div class="overlay" v-if="isMobile && !expandedMenu" @click="toggleMenu()"></div>
    <div class="content_wrapper w-full">
      <div class="header" :class="{ 'shrink-header': !expandedMenu && !this.isMobile }">
        <TheHeader />
        <div class="text-left flex px-3 py-3 bg-white items-center">
          <div class="texl-lg font-bold py-1 border-r-2 border-neutral-600 leading-none pr-2">{{ $route.name }}</div>
          <router-link to="/dashboard" class="pl-2 text-xs text-neutral-500 pr-2">Dashboard</router-link>
          <span v-if="$route.name !== 'Dashboard'" class="inline-block text-xs text-neutral-700">/ {{ $route.name }}</span>
        </div>
      </div>
      <div class="panel min-h-contain flex-col">
        <div class="w-full px-10 py-6 mdmax:w-full mdmax:mx-0 mdmax:px-4 mdmax:py-4">
          <router-view></router-view>
        </div>
      </div>
      <div class="bg-neutral-600 py-4">
        <div class="px-7 mx-auto flex justify-between items-center mdmax:px-7 mdmax:flex-col mdmax:gap-2">
          <p class="text-white text-xs">© {{ year }} Linknau. All Rights Reserved.</p>
          <div class="flex gap-6 items-center">
            <a href="https://www.linknau.id/syarat-ketentuan" target="_blank" class="text-white text-xs">Terms & Condition</a>
            <a href="https://www.linknau.id/kebijakan-privasi" target="_blank" class="text-white text-xs">Privacy Policy</a>
          </div>
        </div>
      </div>
      <Toast />
      <Modal :modalVisible="isAddressModalVisible" @close="toggleModal()" width="600px" id="address-modal">
        <template slot="modal-content">
          <AddAddress @close="toggleModal()" @refresh="refreshAddressList" />
        </template>
      </Modal>
    </div>
    <div class="user-sidebar" :class="[visibleProfileScreen ? 'open' : 'close']">
      <div class="flex gap-2 p-3 items-center sticky">
        <span class="inline-block cursor-pointer" @click="toggleUserSidebar()"><Close /></span>
        <p class="text-lg font-bold" v-if="activeComponent">{{ sidebarItem[activeComponent]?.title }}</p>
      </div>
      <component :is="sidebarItem[activeComponent]?.component" @dismiss="toggleUserSidebar()" v-if="activeComponent" />
    </div>
    <div class="sidebar-backdrop cursor-pointer" :class="{ open: visibleProfileScreen }" @click="toggleUserSidebar()"></div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { enableScrollLock, disableScrollLock } from '@/util'
export default {
  components: {
    TheHeader: () => import(/* webpackChunkName: "header" */ '@/containers/TheHeader'),
    Toast: () => import(/* webpackChunkName: "Toast" */ '@/components/Toast/Toast'),
    TheSidebar: () => import(/* webpackChunkName: "sidebar" */ '@/containers/TheSidebar'),
    TheMobileSidebar: () => import(/* webpackChunkName: "sidebar" */ '@/containers/TheMobileSidebar'),
    Modal: () => import('@/components/Modal/Modal'),
    AddAddress: () => import('@/components/Profile/AddAddress'),
    Close: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Close')
  },
  data() {
    return {
      visibleUserSidebar: false,
      sidebarItem: {
        PROFILE: {
          title: 'Profil',
          component: () => import('@/components/Profile/Profile')
        },
        PASSWORD: {
          title: 'Ubah Password',
          component: () => import('@/components/Profile/ChangePassword')
        },
        ADDRESS: {
          title: 'Alamat Pengirim',
          component: () => import('@/components/Profile/Address')
        },
        PARTNER_PROFILE: {
          title: 'Lengkapi Profil Mitra',
          component: () => import('@/components/Profile/PartnerProfileForm')
        }
      },
      sidebarObject: null
    }
  },
  computed: {
    ...mapGetters('common', ['expandedMenu', 'isMobile', 'visibleProfileScreen', 'activeComponent']),
    ...mapGetters('merchant', ['isAddressModalVisible']),
    year() {
      const d = new Date()
      let year = d.getFullYear()
      return year
    }
  },
  watch: {
    expandedMenu(value) {
      if (this.isMobile) {
        if (value) {
          disableScrollLock()
        } else {
          enableScrollLock()
        }
      }
    },
    visibleProfileScreen(value) {
      if (value) {
        enableScrollLock()
      } else {
        this.sidebarObject = null
        disableScrollLock()
      }
    }
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading', 'expandMenu', 'toggleProfileScreen']),
    ...mapActions('merchant', ['toggleAddressModal', 'getAddresses']),
    toggleMenu() {
      const state = this.expandedMenu
      this.expandMenu(!state)
    },
    toggleModal() {
      this.toggleAddressModal(!this.isAddressModalVisible)
    },
    toggleUserSidebar(state) {
      this.toggleProfileScreen({
        options: {
          value: !this.visibleProfileScreen,
          activeComponent: this.sidebarObject
        }
      })
    },
    refreshAddressList() {
      this.getAddresses({ params: '' })
    }
  }
}
</script>
<style lang="scss" scoped>
.navbar {
  flex: 0 0 200px;
  position: relative;
  transition: all ease-in 300ms;
}
.shrink-menu {
  flex: 0 0 56px;
}
.header {
  position: fixed;
  width: calc(100% - 200px);
  color: #101840;
  transition: all ease-in 300ms;
  margin-left: 200px;
  left: 0;
  top: 0;
  z-index: 10;
  @media screen and (max-width: 767px) {
    margin-left: 0;
    width: 100%;
  }
}
.expand-menu {
  transform: translateX(0) !important;
}
.mobile-sidebar {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  width: 280px;
  height: 100%;
  transform: translateX(-100%);
  transition: transform 300ms ease-in-out;
}
.overlay {
  background-color: rgba(0, 0, 0, 0.75);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 15;
}
.shrink-header {
  margin-left: 56px;
  width: calc(100% - 56px);
}
.panel {
  z-index: 2;
  text-align: left;
  padding-top: 123px;
}

.user-sidebar {
  position: fixed;
  width: 384px;
  height: 100%;
  z-index: 100;
  top: 0;
  right: 0;
  background-color: #fff;
  text-align: left;
  transition: all ease-in-out 300ms;
  overflow: auto;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
  &.close {
    transform: translateX(100%);
  }
  &.open {
    transform: translateX(0%);
  }
}
.sidebar-backdrop {
  left: 0;
  top: 0;
  position: fixed;
  background-color: rgba(16, 24, 64, 0.5);
  width: 100%;
  height: 100%;
  z-index: 99;
  visibility: hidden;
  opacity: 0;
  transition: all ease-in 300ms;
  &.open {
    visibility: visible;
    opacity: 1;
  }
}
</style>
